// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_PHOTOS = ["%(counter)s fotka", "%(counter)s fotky", "%(counter)s fotiek"];
export const READ_WHOLE_EXPERIENCE = "\u010c\u00edtaj cel\u00e9 hodnotenie";
export const READ_WHOLE_REVIEW = "\u010c\u00edtaj cel\u00e9...";
